import React, { useState, useMemo } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const InformeEstadisticasSanciones = () => {
  const [formData, setFormData] = useState({
    sede: '',
    estado: '',
    fechaDesde: '',
    fechaHasta: '',
  });

  const [loading, setLoading] = useState(false);
  const [sanciones, setSanciones] = useState([]);
  const [vista, setVista] = useState('detalle');

  const [sortConfig, setSortConfig] = useState({
    key: 'cadeteDni',
    direction: 'asc',
  });

  const [veoConsultasSanciones, setVeoConsultasSanciones] =
    useState(false);

  /* =========================================================
     OBTENER CANTIDAD FINAL

     PRIORIDAD:

     1. cantidadResuelveRecurso
     2. cantidadConfirma
     3. cantidad
     ========================================================= */

  const obtenerCantidadFinal = (sancion) => {
    return (
      sancion?.cantidadResuelveRecurso ??
      sancion?.cantidadConfirma ??
      sancion?.cantidad ??
      ''
    );
  };

  /* =========================================================
     CAMBIO DE FILTROS
     ========================================================= */

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /* =========================================================
     BUSCAR SANCIONES
     ========================================================= */

  const fetchSanciones = async () => {
    setLoading(true);

    try {
      const token = btoa(
        `${process.env.REACT_APP_KEY}:${process.env.REACT_APP_PASS}`
      );

      const client = axios.create({
        baseURL: `${process.env.REACT_APP_BASEURL}NCadetes/obtieneTodasLasSanciones`,
        headers: {
          Authorization: `Basic ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const consulta = {
        sede: formData.sede || undefined,
        estado: formData.estado || undefined,
        fechaDesde: formData.fechaDesde || undefined,
        fechaHasta: formData.fechaHasta || undefined,
      };

      /*
      console.log('==============================================');
      console.log('🔥 CONSULTANDO SANCIONES');
      console.log('==============================================');
      console.log('📤 Consulta enviada:', consulta);
      */

      const res = await client.post('/', consulta);

      /*
      console.log('==============================================');
      console.log('🔥 RESPUESTA COMPLETA DEL BACKEND');
      console.log('==============================================');
      console.log(res.data);
      */

      const listaSanciones = res.data?.Sancioness || [];

      /*
      console.log('==============================================');
      console.log('🔥 SANCIONES RECIBIDAS');
      console.log('==============================================');

      console.log('Cantidad total:', listaSanciones.length);
      console.log(listaSanciones);
      */

      if (listaSanciones.length > 0) {
        /*
        console.log('==============================================');
        console.log('🔥 PRIMER REGISTRO');
        console.log('==============================================');

        console.log(listaSanciones[0]);

        console.log(
          'cantidad:',
          listaSanciones[0]?.cantidad
        );

        console.log(
          'cantidadConfirma:',
          listaSanciones[0]?.cantidadConfirma
        );

        console.log(
          'cantidadResuelveRecurso:',
          listaSanciones[0]?.cantidadResuelveRecurso
        );

        console.log(
          '🔥 CANTIDAD FINAL:',
          obtenerCantidadFinal(listaSanciones[0])
        );

        console.table(
          listaSanciones.slice(0, 20).map((s) => ({
            dni: s.cadeteDni,
            cantidad: s.cantidad,
            cantidadConfirma: s.cantidadConfirma,
            cantidadResuelveRecurso:
              s.cantidadResuelveRecurso,
            cantidadFinal:
              obtenerCantidadFinal(s),
          }))
        );
        */
      }

      setSanciones(listaSanciones);
    } catch (err) {
      /*
      console.error('==============================================');
      console.error('❌ ERROR BUSCANDO SANCIONES');
      console.error('==============================================');
      console.error(err);

      if (err.response) {
        console.error(
          'Respuesta servidor:',
          err.response.data
        );

        console.error(
          'Status:',
          err.response.status
        );
      }
      */

      setSanciones([]);
    } finally {
      setLoading(false);
    }
  };

  /* =========================================================
     DÍAS DE LA SEMANA
     ========================================================= */

  const diasSemana = [
    'Domingo',
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sabado',
  ];

  /* =========================================================
     RESUMEN
     ========================================================= */

  const resumenData = () => {
    const incisoCounter = {};
    const estadoCounter = {};
    const tipoCounter = {};
    const tiempos = [];
    const resumenPorDia = {};

    sanciones.forEach((s) => {
      const fechaFalta = s.fechaFaltaCometida
        ? new Date(s.fechaFaltaCometida)
        : null;

      const creado = s.createdAt
        ? new Date(s.createdAt)
        : null;

      const notificado = s.fechaNotificado
        ? new Date(s.fechaNotificado)
        : null;

      /* =========================
         DÍA
         ========================= */

      if (fechaFalta) {
        const fechaLocal = new Date(
          fechaFalta.getTime() + 3 * 60 * 60 * 1000
        );

        const dia =
          diasSemana[fechaLocal.getDay()];

        resumenPorDia[dia] =
          (resumenPorDia[dia] || 0) + 1;
      }

      /* =========================
         INCISOS
         ========================= */

      const clave = `${s.tipo || 'Sin tipo'} - ${
        s.inciso || 'Sin inciso'
      }`;

      incisoCounter[clave] =
        (incisoCounter[clave] || 0) + 1;

      /* =========================
         ESTADO
         ========================= */

      estadoCounter[
        s.estado || 'Sin estado'
      ] =
        (estadoCounter[
          s.estado || 'Sin estado'
        ] || 0) + 1;

      /* =========================
         TIPO
         ========================= */

      tipoCounter[
        s.tipo || 'Sin tipo'
      ] =
        (tipoCounter[
          s.tipo || 'Sin tipo'
        ] || 0) + 1;

      /* =========================
         TIEMPOS
         ========================= */

      if (fechaFalta && creado) {
        tiempos.push({
          DNI: s.cadeteDni,

          FechaFalta:
            fechaFalta
              .toISOString()
              .split('T')[0],

          FechaSancion:
            creado
              .toISOString()
              .split('T')[0],

          FechaNotificado:
            notificado
              ? notificado
                  .toISOString()
                  .split('T')[0]
              : '',

          DiasHastaSancion:
            Math.round(
              (creado - fechaFalta) /
                (1000 * 60 * 60 * 24)
            ),

          DiasSancionANotifica:
            notificado
              ? Math.round(
                  (notificado - creado) /
                    (1000 * 60 * 60 * 24)
                )
              : '',

          DiasTotales:
            notificado
              ? Math.round(
                  (notificado - fechaFalta) /
                    (1000 * 60 * 60 * 24)
                )
              : '',
        });
      }
    });

    return {
      incisoCounter,
      estadoCounter,
      tipoCounter,
      tiempos,
      resumenPorDia,
    };
  };

  const {
    incisoCounter,
    estadoCounter,
    tipoCounter,
    tiempos,
    resumenPorDia,
  } = resumenData();

  /* =========================================================
     EXPORTAR EXCEL
     ========================================================= */

  const exportarEstadisticas = () => {
    /*
    console.log('==============================================');
    console.log('🔥 EXPORTANDO ESTADÍSTICAS');
    console.log('==============================================');

    console.log(
      sanciones.map((s) => ({
        dni: s.cadeteDni,
        cantidadOriginal: s.cantidad,
        cantidadConfirma:
          s.cantidadConfirma,
        cantidadResuelveRecurso:
          s.cantidadResuelveRecurso,
        cantidadFinal:
          obtenerCantidadFinal(s),
      }))
    );
    */

    const detalle = sanciones.map(
      (s, i) => ({
        Nro: i + 1,

        DNI:
          s.cadeteDni ?? '',

        Apellido:
          s.cadete?.cadeteApellido ??
          '',

        Nombre:
          s.cadete?.cadeteNombre ??
          '',

        Sede:
          s.cadete?.cadeteSede?.trim() ??
          '',

        Promocion:
          s.cadete?.Promocions?.[0]
            ?.nombre ?? '',

        Tipo:
          s.tipo ?? '',

        /* =====================================
           UNA SOLA CANTIDAD
           ===================================== */

        Cantidad:
          obtenerCantidadFinal(s),

        Inciso:
          s.inciso ?? '',

        Estado:
          s.estado ?? '',

        FechaFalta:
          s.fechaFaltaCometida ?? '',

        FechaSancion:
          s.createdAt ?? '',

        FechaNotificado:
          s.fechaNotificado ?? '',
      })
    );

    /*
    console.log(
      '🔥 DETALLE QUE VA AL EXCEL:',
      detalle
    );

    console.table(
      detalle.slice(0, 20)
    );
    */

    const incisos = Object.entries(
      incisoCounter
    ).map(([k, v]) => ({
      Inciso: k,
      Cantidad: v,
    }));

    const estados = Object.entries(
      estadoCounter
    ).map(([k, v]) => ({
      Estado: k,
      Cantidad: v,
    }));

    const tipos = Object.entries(
      tipoCounter
    ).map(([k, v]) => ({
      Tipo: k,
      Cantidad: v,
    }));

    const dias = Object.entries(
      resumenPorDia
    ).map(([k, v]) => ({
      Dia: k,
      Cantidad: v,
    }));

    const wb =
      XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      wb,
      XLSX.utils.json_to_sheet(
        detalle
      ),
      'Detalle'
    );

    XLSX.utils.book_append_sheet(
      wb,
      XLSX.utils.json_to_sheet(
        incisos
      ),
      'Incisos Frecuentes'
    );

    XLSX.utils.book_append_sheet(
      wb,
      XLSX.utils.json_to_sheet(
        estados
      ),
      'Por Estado'
    );

    XLSX.utils.book_append_sheet(
      wb,
      XLSX.utils.json_to_sheet(
        tipos
      ),
      'Por Tipo'
    );

    XLSX.utils.book_append_sheet(
      wb,
      XLSX.utils.json_to_sheet(
        tiempos
      ),
      'Tiempos Sanción'
    );

    XLSX.utils.book_append_sheet(
      wb,
      XLSX.utils.json_to_sheet(
        dias
      ),
      'Días Comunes'
    );

    const buffer =
      XLSX.write(wb, {
        bookType: 'xlsx',
        type: 'array',
      });

    const archivo =
      new Blob(
        [buffer],
        {
          type: 'application/octet-stream',
        }
      );

    const fechaArchivo =
      new Date()
        .toLocaleDateString()
        .replace(/\//g, '-');

    saveAs(
      archivo,
      `estadisticas_sanciones_${fechaArchivo}.xlsx`
    );
  };

  /* =========================================================
     VALOR POR CLAVE
     ========================================================= */

  const getValueByKey = (
    obj,
    key
  ) => {
    return (
      key
        .split('.')
        .reduce(
          (o, k) =>
            o !== null &&
            o !== undefined
              ? o[k]
              : '',
          obj
        ) ?? ''
    );
  };

  /* =========================================================
     ORDENAR SANCIONES
     ========================================================= */

  const sortedSanciones =
    useMemo(() => {
      if (!sanciones) return [];

      const items =
        [...sanciones];

      if (sortConfig !== null) {
        items.sort((a, b) => {
          let aVal;
          let bVal;

          /*
           * Para la columna Cantidad
           * usamos la cantidad final calculada.
           */
          if (
            sortConfig.key ===
            'cantidadFinal'
          ) {
            aVal =
              obtenerCantidadFinal(a);

            bVal =
              obtenerCantidadFinal(b);
          } else {
            aVal =
              getValueByKey(
                a,
                sortConfig.key
              );

            bVal =
              getValueByKey(
                b,
                sortConfig.key
              );
          }

          if (
            typeof aVal ===
              'string' &&
            typeof bVal ===
              'string'
          ) {
            if (
              sortConfig.direction ===
              'asc'
            ) {
              return aVal.localeCompare(
                bVal
              );
            }

            return bVal.localeCompare(
              aVal
            );
          }

          if (
            sortConfig.direction ===
            'asc'
          ) {
            return aVal > bVal
              ? 1
              : aVal < bVal
              ? -1
              : 0;
          }

          return aVal < bVal
            ? 1
            : aVal > bVal
            ? -1
            : 0;
        });
      }

      return items;
    }, [sanciones, sortConfig]);

  /* =========================================================
     ORDENAR TIEMPOS
     ========================================================= */

  const sortedTiempos =
    useMemo(() => {
      if (!tiempos) return [];

      const items =
        [...tiempos];

      if (
        sortConfig !== null &&
        vista === 'tiempos'
      ) {
        items.sort((a, b) => {
          const aVal =
            a[sortConfig.key] ?? '';

          const bVal =
            b[sortConfig.key] ?? '';

          if (
            typeof aVal ===
              'string' &&
            typeof bVal ===
              'string'
          ) {
            if (
              sortConfig.direction ===
              'asc'
            ) {
              return aVal.localeCompare(
                bVal
              );
            }

            return bVal.localeCompare(
              aVal
            );
          }

          if (
            sortConfig.direction ===
            'asc'
          ) {
            return aVal > bVal
              ? 1
              : aVal < bVal
              ? -1
              : 0;
          }

          return aVal < bVal
            ? 1
            : aVal > bVal
            ? -1
            : 0;
        });
      }

      return items;
    }, [
      tiempos,
      sortConfig,
      vista,
    ]);

  /* =========================================================
     CAMBIAR ORDEN
     ========================================================= */

  const requestSort = (key) => {
    let direction = 'asc';

    if (
      sortConfig.key === key &&
      sortConfig.direction === 'asc'
    ) {
      direction = 'desc';
    }

    setSortConfig({
      key,
      direction,
    });
  };

  const getSortIndicator = (
    key
  ) => {
    if (
      sortConfig.key === key
    ) {
      return sortConfig.direction ===
        'asc'
        ? '↑'
        : '↓';
    }

    return '';
  };

  /* =========================================================
     VISTAS
     ========================================================= */

  const renderVista = () => {
    /* =======================================================
       DETALLE
       ======================================================= */

    if (vista === 'detalle') {
      return (
        <div className="overflow-x-auto">

          <table className="w-full border-collapse border border-gray-300 text-sm mt-4">

            <thead>

              <tr className="bg-gray-100">

                <th
                  className="border border-gray-300 p-2 cursor-pointer select-none"
                  onClick={() =>
                    requestSort(
                      'cadeteDni'
                    )
                  }
                >
                  DNI{' '}
                  {getSortIndicator(
                    'cadeteDni'
                  )}
                </th>

                <th
                  className="border border-gray-300 p-2 cursor-pointer select-none"
                  onClick={() =>
                    requestSort(
                      'cadete.cadeteApellido'
                    )
                  }
                >
                  Apellido{' '}
                  {getSortIndicator(
                    'cadete.cadeteApellido'
                  )}
                </th>

                <th
                  className="border border-gray-300 p-2 cursor-pointer select-none"
                  onClick={() =>
                    requestSort(
                      'cadete.cadeteNombre'
                    )
                  }
                >
                  Nombre{' '}
                  {getSortIndicator(
                    'cadete.cadeteNombre'
                  )}
                </th>

                <th
                  className="border border-gray-300 p-2 cursor-pointer select-none"
                  onClick={() =>
                    requestSort(
                      'cadete.cadeteSede'
                    )
                  }
                >
                  Sede{' '}
                  {getSortIndicator(
                    'cadete.cadeteSede'
                  )}
                </th>

                <th
                  className="border border-gray-300 p-2 cursor-pointer select-none"
                  onClick={() =>
                    requestSort(
                      'cadete.Promocions.0.nombre'
                    )
                  }
                >
                  Promoción{' '}
                  {getSortIndicator(
                    'cadete.Promocions.0.nombre'
                  )}
                </th>

                <th
                  className="border border-gray-300 p-2 cursor-pointer select-none"
                  onClick={() =>
                    requestSort(
                      'tipo'
                    )
                  }
                >
                  Tipo{' '}
                  {getSortIndicator(
                    'tipo'
                  )}
                </th>

                {/* =========================
                    UNA SOLA COLUMNA
                    DE CANTIDAD
                    ========================= */}

                <th
                  className="border border-gray-300 p-2 cursor-pointer select-none text-center"
                  onClick={() =>
                    requestSort(
                      'cantidadFinal'
                    )
                  }
                >
                  Cantidad{' '}
                  {getSortIndicator(
                    'cantidadFinal'
                  )}
                </th>

                <th
                  className="border border-gray-300 p-2 cursor-pointer select-none"
                  onClick={() =>
                    requestSort(
                      'inciso'
                    )
                  }
                >
                  Inciso{' '}
                  {getSortIndicator(
                    'inciso'
                  )}
                </th>

              </tr>

            </thead>

            <tbody>

              {sortedSanciones.map(
                (s, i) => (

                  <tr
                    key={
                      s.id ||
                      `${s.cadeteDni}-${i}`
                    }
                    className={
                      i % 2 === 0
                        ? 'bg-white'
                        : 'bg-gray-50'
                    }
                  >

                    <td className="border border-gray-300 p-2">
                      {s.cadeteDni ??
                        ''}
                    </td>

                    <td className="border border-gray-300 p-2">
                      {s.cadete
                        ?.cadeteApellido ??
                        ''}
                    </td>

                    <td className="border border-gray-300 p-2">
                      {s.cadete
                        ?.cadeteNombre ??
                        ''}
                    </td>

                    <td className="border border-gray-300 p-2">
                      {s.cadete
                        ?.cadeteSede
                        ?.trim() ?? ''}
                    </td>

                    <td className="border border-gray-300 p-2">
                      {s.cadete
                        ?.Promocions?.[0]
                        ?.nombre ?? ''}
                    </td>

                    <td className="border border-gray-300 p-2">
                      {s.tipo ?? ''}
                    </td>

                    {/* =====================
                        CANTIDAD FINAL

                        Resolución recurso
                              ↓
                        Confirmada
                              ↓
                        Original
                        ===================== */}

                    <td className="border border-gray-300 p-2 text-center font-semibold">
                      {obtenerCantidadFinal(
                        s
                      ) !== ''
                        ? obtenerCantidadFinal(
                            s
                          )
                        : '-'}
                    </td>

                    <td className="border border-gray-300 p-2">
                      {s.inciso ?? ''}
                    </td>

                  </tr>

                )
              )}

            </tbody>

          </table>

        </div>
      );
    }

    /* =======================================================
       INCISOS
       ======================================================= */

    if (vista === 'incisos') {
      return (
        <ul className="mt-4">

          {Object.entries(
            incisoCounter
          ).map(([k, v]) => (

            <li key={k}>
              {k}: {v}
            </li>

          ))}

        </ul>
      );
    }

    /* =======================================================
       TIEMPOS
       ======================================================= */

    if (vista === 'tiempos') {
      return (
        <div className="overflow-x-auto">

          <table className="w-full border-collapse border border-gray-300 text-sm mt-4">

            <thead>

              <tr className="bg-gray-100">

                <th
                  className="border border-gray-300 p-2 cursor-pointer select-none"
                  onClick={() =>
                    requestSort('DNI')
                  }
                >
                  DNI{' '}
                  {getSortIndicator(
                    'DNI'
                  )}
                </th>

                <th
                  className="border border-gray-300 p-2 cursor-pointer select-none"
                  onClick={() =>
                    requestSort(
                      'FechaFalta'
                    )
                  }
                >
                  Falta{' '}
                  {getSortIndicator(
                    'FechaFalta'
                  )}
                </th>

                <th
                  className="border border-gray-300 p-2 cursor-pointer select-none"
                  onClick={() =>
                    requestSort(
                      'FechaSancion'
                    )
                  }
                >
                  Sanción{' '}
                  {getSortIndicator(
                    'FechaSancion'
                  )}
                </th>

                <th
                  className="border border-gray-300 p-2 cursor-pointer select-none"
                  onClick={() =>
                    requestSort(
                      'FechaNotificado'
                    )
                  }
                >
                  Notificación{' '}
                  {getSortIndicator(
                    'FechaNotificado'
                  )}
                </th>

                <th
                  className="border border-gray-300 p-2 cursor-pointer select-none"
                  onClick={() =>
                    requestSort(
                      'DiasHastaSancion'
                    )
                  }
                >
                  Días hasta sanción{' '}
                  {getSortIndicator(
                    'DiasHastaSancion'
                  )}
                </th>

                <th
                  className="border border-gray-300 p-2 cursor-pointer select-none"
                  onClick={() =>
                    requestSort(
                      'DiasSancionANotifica'
                    )
                  }
                >
                  Días sanción → notifica{' '}
                  {getSortIndicator(
                    'DiasSancionANotifica'
                  )}
                </th>

                <th
                  className="border border-gray-300 p-2 cursor-pointer select-none"
                  onClick={() =>
                    requestSort(
                      'DiasTotales'
                    )
                  }
                >
                  Total días{' '}
                  {getSortIndicator(
                    'DiasTotales'
                  )}
                </th>

              </tr>

            </thead>

            <tbody>

              {sortedTiempos.map(
                (t, i) => (

                  <tr
                    key={i}
                    className={
                      i % 2 === 0
                        ? 'bg-white'
                        : 'bg-gray-50'
                    }
                  >

                    <td className="border border-gray-300 p-2">
                      {t.DNI}
                    </td>

                    <td className="border border-gray-300 p-2">
                      {t.FechaFalta}
                    </td>

                    <td className="border border-gray-300 p-2">
                      {t.FechaSancion}
                    </td>

                    <td className="border border-gray-300 p-2">
                      {t.FechaNotificado}
                    </td>

                    <td className="border border-gray-300 p-2">
                      {t.DiasHastaSancion}
                    </td>

                    <td className="border border-gray-300 p-2">
                      {t.DiasSancionANotifica}
                    </td>

                    <td className="border border-gray-300 p-2">
                      {t.DiasTotales}
                    </td>

                  </tr>

                )
              )}

            </tbody>

          </table>

        </div>
      );
    }

    /* =======================================================
       ESTADO
       ======================================================= */

    if (vista === 'estado') {
      return (
        <ul className="mt-4">

          {Object.entries(
            estadoCounter
          ).map(([k, v]) => (

            <li key={k}>
              {k}: {v}
            </li>

          ))}

        </ul>
      );
    }

    /* =======================================================
       TIPO
       ======================================================= */

    if (vista === 'tipo') {
      return (
        <ul className="mt-4">

          {Object.entries(
            tipoCounter
          ).map(([k, v]) => (

            <li key={k}>
              {k}: {v}
            </li>

          ))}

        </ul>
      );
    }

    /* =======================================================
       DÍAS
       ======================================================= */

    if (vista === 'dias') {
      return (
        <ul className="mt-4">

          {Object.entries(
            resumenPorDia
          ).map(([k, v]) => (

            <li key={k}>
              {k}: {v}
            </li>

          ))}

        </ul>
      );
    }

    return null;
  };

  /* =========================================================
     JSX PRINCIPAL
     ========================================================= */

  return (
    <div className="max-w-6xl mx-auto">

      <h1
        className="text-lg font-bold mb-4 btn btn-primary"
        onClick={() =>
          setVeoConsultasSanciones(
            !veoConsultasSanciones
          )
        }
      >
        Consultas de Sanciones
      </h1>

      {veoConsultasSanciones ? (
        <>

          {/* =================================================
              FILTROS
              ================================================= */}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">

            <select
              name="sede"
              value={formData.sede}
              onChange={handleChange}
              className="p-2 border rounded"
            >

              <option value="">
                -- Todas --
              </option>

              <option value="Rosario">
                Rosario
              </option>

              <option value="Recreo">
                Recreo
              </option>

            </select>

            <select
              name="estado"
              value={formData.estado}
              onChange={handleChange}
              className="p-2 border rounded"
            >

              <option value="">
                -- Seleccione Estado --
              </option>

              <option value="Activa">
                Activa
              </option>

              <option value="Anulada">
                Anulada
              </option>

              <option value="Confirmada">
                Confirmada
              </option>

              <option value="Finalizada">
                Finalizada
              </option>

              <option value="Sin Efecto">
                Sin Efecto
              </option>

              <option value="Para Confirmar">
                Para Confirmar
              </option>

              <option value="Reclamada">
                Reclamada
              </option>

              <option value="Finalizada Reclamada">
                Finalizada Reclamada
              </option>

              <option value="Resuelto Reclamada">
                Resuelto Reclamada
              </option>

            </select>

            <input
              type="date"
              name="fechaDesde"
              value={
                formData.fechaDesde
              }
              onChange={handleChange}
              className="p-2 border rounded"
            />

            <input
              type="date"
              name="fechaHasta"
              value={
                formData.fechaHasta
              }
              onChange={handleChange}
              className="p-2 border rounded"
            />

          </div>

          {/* =================================================
              BOTONES
              ================================================= */}

          <div className="flex gap-2 mb-4 flex-wrap">

            <button
              onClick={
                fetchSanciones
              }
              className="btn btn-primary"
              disabled={loading}
            >
              {loading
                ? 'Cargando...'
                : 'Buscar'}
            </button>

            {sanciones.length >
              0 && (
              <>

                <button
                  onClick={
                    exportarEstadisticas
                  }
                  className="btn btn-success"
                >
                  Descargar Excel
                </button>

                <button
                  onClick={() => {
                    setVista(
                      'detalle'
                    );

                    setSortConfig({
                      key:
                        'cadeteDni',
                      direction:
                        'asc',
                    });
                  }}
                  className="btn btn-outline btn-info"
                >
                  Detalle
                </button>

                <button
                  onClick={() =>
                    setVista(
                      'incisos'
                    )
                  }
                  className="btn btn-outline btn-warning"
                >
                  Incisos Frecuentes
                </button>

                <button
                  onClick={() => {
                    setVista(
                      'tiempos'
                    );

                    setSortConfig({
                      key: 'DNI',
                      direction:
                        'asc',
                    });
                  }}
                  className="btn btn-outline btn-primary"
                >
                  Tiempos
                </button>

                <button
                  onClick={() =>
                    setVista(
                      'estado'
                    )
                  }
                  className="btn btn-outline btn-secondary"
                >
                  Por Estado
                </button>

                <button
                  onClick={() =>
                    setVista(
                      'tipo'
                    )
                  }
                  className="btn btn-outline btn-success"
                >
                  Por Tipo
                </button>

                <button
                  onClick={() =>
                    setVista(
                      'dias'
                    )
                  }
                  className="btn btn-outline btn-danger"
                >
                  Días comunes
                </button>

              </>
            )}

          </div>

          {/* =================================================
              TOTAL
              ================================================= */}

          {sanciones.length >
            0 && (
            <div className="mb-2">

              <strong>
                Total de sanciones:
              </strong>{' '}

              {sanciones.length}

            </div>
          )}

          {renderVista()}

        </>
      ) : null}

    </div>
  );
};

export default InformeEstadisticasSanciones;